/** Shared apply-form field ordering helpers (docx / candidate apply flow). */
export const PRE_RESUME_QUESTION_TEXTS = [
  'Phone number',
  'City',
  'State',
  'Cover letter (optional)',
];

export const PRE_RESUME_TEXT_SET = new Set(PRE_RESUME_QUESTION_TEXTS);

export function splitQuestionsForApplyPreview(questions = []) {
  const pre = [];
  const post = [];
  for (const q of questions) {
    if (PRE_RESUME_TEXT_SET.has(q.question_text)) {
      pre.push(q);
    } else {
      post.push(q);
    }
  }
  pre.sort((a, b) => {
    const ai = PRE_RESUME_QUESTION_TEXTS.indexOf(a.question_text);
    const bi = PRE_RESUME_QUESTION_TEXTS.indexOf(b.question_text);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });
  return { pre, post };
}
